export const setUrl = ({
  baseUrl,
  productId,
  code,
  redirectUrl,
  transcriptionId,
}: {
  baseUrl: string;
  productId: string;
  code: string;
  redirectUrl: string;
  transcriptionId: string;
}) => {
  const url = new URL(baseUrl);
  url.searchParams.set('product_id', productId);
  if (code) url.searchParams.set('code', code);
  if (redirectUrl) url.searchParams.set('redirect_url', redirectUrl);
  if (transcriptionId) url.searchParams.set('transcription_id', transcriptionId);
  return url.toString();
};

export default { setUrl };
